var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 26h40v-26h-40z",
    fill: "#016fd0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.71 13.64v1.64h-4.17v1.14h4.07v1.64h-4.07v1.12h4.17v1.66l3.38-3.6zm-1.1-6.14-1.4-3.19h-4l-4.1 9.32h3.33v8.27h10.28l1.61-1.8 1.67 1.81h3v-2.63l-1.9-2.06 1.92-2v-2.64h-1.93v-5l-1.81 5h-1.76l-1.86-5v5h-4.2l-.6-1.46h-3.3l-.56 1.47h-2.26l3.26-7.27h2.55l3.19 7.21v-7.22h3.1l1.6 4.47 1.56-4.47h3v-1h-3.75l-.85 2.39-.85-2.39h-4.94zm-5.06 6.11v7.27h8.7l2.1-2.32 2.12 2.32h2.53v-.1l-3.34-3.53 3.34-3.59v-.05h-2.5l-2.1 2.3-2.08-2.3zm.7-4.11 1-2.31 1 2.31z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAmex);
export default __webpack_public_path__ + "static/media/card-amex.49f750773d39d45e8be5ac919ce15547.svg";
export { ForwardRef as ReactComponent };